import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
	catchError,
	distinctUntilChanged,
	filter,
	map,
	merge,
	switchMap,
	tap,
	withLatestFrom,
	of,
} from 'rxjs';
import { CampusLocationsApiService } from '../campus-locations-api.service';

import {
	loadStateCampusLocationsFailure,
	fetchCampusesList,
	updateCampusesList,
	updateCampusLocationsUniversityUrl,
} from './campus-locations.actions';
import { CampusLocationsState } from './campus-locations.reducer';
import {
	getStateCampusLocations,
	getStateCampusLocationsUniversityUrl,
} from './campus-locations.selectors';

@Injectable()
export class StateCampusLocationsEffects {
	constructor(
		private readonly _actions$: Actions,
		private _service: CampusLocationsApiService,
		private _store: Store<CampusLocationsState>,
	) {}

	fetchCampuses = createEffect(() =>
		this._actions$.pipe(
			ofType(fetchCampusesList),
			distinctUntilChanged(),
			withLatestFrom(
				this._store.select(getStateCampusLocations),
				this._store.select(getStateCampusLocationsUniversityUrl), // university id from store
			),
			filter(([payload, campus, universityUrl]) => {
				// continue the stream if no data
				// or if the current universityId !== universityId from store
				if (!campus || payload.universityUrl !== universityUrl) {
					return true;
				}
				// canceling the stream
				return false;
			}),
			tap(([payload]) =>
				this._store.dispatch(updateCampusLocationsUniversityUrl(payload)),
			),
			switchMap(([payload]) =>
				// the of operator is used for resetting the data in store
				// so the UI is updated and avoid printing the current data from store
				merge(of(null), this._service.getCampusesList(payload)),
			),
			map((response) => updateCampusesList(response)),
			catchError(async (error) => loadStateCampusLocationsFailure(error)),
		),
	);
}
